import { useEffect, useState } from "react";
import Courses from "./Courses/Courses";
import PastCourses from "./PastCourses/PastCourses";

// fetching data
import useFetch from "Hooks/useFetch";
import LoadingScreen from "Components/RequestHandler/LoadingScreen";
import IsError from "Components/RequestHandler/IsError";

const TraniningAndWorkShop = () => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData(`academy-training-and-workShop`);
      setData(data);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <section className="col-span-3">
      <Courses loading={isLoading} data={data?.upcoming_training_courses} />
      <PastCourses loading={isLoading} data={data?.past_training_courses} />
    </section>
  );
};

export default TraniningAndWorkShop;
